import { useEffect } from 'react';
import { closeAllModals } from '@/features/serviceModal/store/serviceModalSlice';
import { useDispatch } from '@/store/hooks';

const useCloseAllModalsOnBack = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const handlePopState = () => {
      dispatch(closeAllModals());
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [dispatch]);
};

export default useCloseAllModalsOnBack;
